import React from 'react'

function IconSlides() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="47" height="49" fill="none" viewBox="0 0 47 49">
      <path
        fill="#13682B"
        fillRule="evenodd"
        d="M10.209 11.504v29.143h22.447V20.002l-8.474-8.498H10.21zm1.247 1.267h11.847v8.236h8.106V39.38H11.456V12.77zm13.094.881l6.07 6.088h-6.07v-6.088zm2.183 10.1a1.174 1.174 0 00-1.18 1.163c.003.64.53 1.16 1.18 1.16.65 0 1.176-.52 1.178-1.16 0-.641-.528-1.161-1.178-1.163zm-7.69 1.69a.616.616 0 00-.526.257l-4.652 6.387a.646.646 0 00-.056.661.622.622 0 00.557.35h9.251l4.06-.053a.622.622 0 00.556-.366.645.645 0 00-.08-.666l-4.058-5.058a.618.618 0 00-.492-.235.624.624 0 00-.495.262l-1.33 1.859-2.255-3.138a.627.627 0 00-.48-.26zm-.027 1.702l2.263 3.15c.002.006.007.01.007.01l1.096 1.525h-6.778l3.412-4.685zm4.623 1.248l2.73 3.402-2.442.033-1.374-1.91 1.086-1.525z"
        clipRule="evenodd"
      ></path>
      <path
        fill="#13682B"
        fillRule="evenodd"
        d="M13.753 8.354h14.825l8.213 8.624v21.306H32.46v-1.181h3.15V17.45l-7.539-7.916H14.934v2.954h-1.181V8.354z"
        clipRule="evenodd"
      ></path>
    </svg>
  )
}

export default IconSlides
